import { render, staticRenderFns } from "./SuComeDown.vue?vue&type=template&id=96bcdd62&scoped=true&"
import script from "./SuComeDown.vue?vue&type=script&lang=js&"
export * from "./SuComeDown.vue?vue&type=script&lang=js&"
import style0 from "./SuComeDown.vue?vue&type=style&index=0&id=96bcdd62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcdd62",
  null
  
)

export default component.exports